import Flex from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled, { css, ITheme } from '../../../theme'
import { INPUT_WIDTH } from '../elements/Input'
import { DecreaseButton, IncreaseButton } from './Button'

const Wrapper = styled(Flex as any)<IWrapper>`
  flex-direction: row;
  align-items: center;

  ${({ smallReservation, size }: IWrapper) =>
    smallReservation
      ? css`
          height: ${size ? 38 * size : 38}px;
        `
      : null};

  border: 1px solid ${(props: ITheme) => props.theme.colors.border};
  border-radius: 4px;
  width: 100%;
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : `${INPUT_WIDTH}px`)};
  padding-left: 10px;
  padding-right: 10px;
  
  & > input {
  ${is('disabled')`
		color: ${(props: ITheme) => props.theme.colors.palette.greyish};
    ${is('safari')`
      color: ${(props: ITheme) => props.theme.colors.palette.battleshipGrey};
    `}
  `};
	}
	
	&:focus {
    outline: none;
  }

  ${is('selected')`
    border: 1px solid ${({ theme }: ITheme) => theme.colors.palette.emerald};
    &:focus {
      border: 1px solid ${({ theme }: ITheme) => theme.colors.palette.emerald};
    }
  `}
  ${is('error')`
    border: 1px solid ${({ theme }: ITheme) => theme.colors.palette.reddish};
    &:focus {
      border: 1px solid ${({ theme }: ITheme) => theme.colors.palette.reddish};
    }
  `}
  ${is('warning')`
    border: 1px solid ${({ theme }: ITheme) => theme.colors.palette.tangerine};
    &:focus {
      border: 1px solid ${({ theme }: ITheme) =>
        theme.colors.palette.tangerine};
    }
  `};
  
    ${is('withoutPicker')`
      padding: 0;
      border: none;
    `}
  
  & > ${DecreaseButton}, & > ${IncreaseButton} {
    ${is('disabled')`
  		background-color: ${(props: ITheme) => props.theme.colors.palette.paleGrey};
  	`}
  }
`

export default Wrapper

export interface IWrapper {
  disabled?: boolean
  safari?: boolean
  selected?: boolean
  error?: boolean
  warning?: boolean
  smallReservation?: boolean
  size?: number
  maxWidth?: string | number
  withoutPicker?: boolean
}
